import { FieldData, FieldInfoGroupField } from '@app/common/configurable-wizards';

export const setFieldValues = <T extends Record<string, FieldData>>(
  field: FieldInfoGroupField,
  values: T,
) => (field && {
    ...field,
    subFields: field.subFields.map((item: any) => (item.id in values ? {
      ...item,
      ...('sValue' in item ? { sValue: values[item.id] } : {}),
      ...('selectedValue' in item ? { selectedValue: values[item.id] } : {}),
    } : item)),
  });

export const getEmptyFields = (fields: Record<string, any>) => (
  Object.values(fields).reduce((acc, key) => ({
    ...acc,
    [key]: '',
  }), {})
);
